import { Box } from "@mui/material";
import Header from "../login/Header";
import Footer from "../navigationbar/Footer";

export default function PublicLayout({ children }) {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      minHeight="100vh" 
      width="100%"
    >
      {/* Header stays fixed at top of the layout */}
      <Header />

      {/* Main content grows to fill available space */}
      <Box component="main" flex={1} width="100%">
        {children}
      </Box>

      {/* Footer at the bottom */}
      <Footer />
    </Box>
  );
}
